export class Canceler {
  cancel = (): void => {
  }
}
